import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import type { Feature } from '@pc/components/Works/Panel/types'
import CheckBoxFeatureInputSet from './CheckBoxFeatureInputSet'
import type { ChangeEvent } from 'react'

interface PropsType {
  features: Feature[]
  selectedFeatureIds: string[]
  changeState: (arg: any) => void
}

const FeatureItem = (props: PropsType) => {
  const { features, selectedFeatureIds, changeState } = props

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedFeatureIds = selectedFeatureIds.concat(value)
      changeState({ selectedFeatureIds: concatedFeatureIds })
    } else {
      const filteredFeatureIds = selectedFeatureIds.filter((selectedFeatureId) => selectedFeatureId !== value)
      changeState({ selectedFeatureIds: filteredFeatureIds })
    }
  }

  const featuresCheckboxes = features.map((feature) => {
    const { id, name } = feature.attributes
    const featureKey = `feature-${id}`
    return (
      <CheckBoxFeatureInputSet key={featureKey}>
        <CheckBoxInput type="checkbox" id={featureKey} value={id} onChange={toggleCheckbox} checked={selectedFeatureIds.includes(String(id))} />
        <CheckBoxLabel htmlFor={featureKey}>{name}</CheckBoxLabel>
      </CheckBoxFeatureInputSet>
    )
  })

  return (
    <ControlGroup>
      <CheckBoxGroup>{featuresCheckboxes}</CheckBoxGroup>
    </ControlGroup>
  )
}

export default FeatureItem
